import { Observable } from '@app/base';

const GLOBAL_CHAT_OPEN_LOCAL_STORAGE_KEY = `${import.meta.env.VITE_PRODUCT_CODE}://chatify/chats/global/open`;
const GLOBAL_CHAT_OPEN_LOCAL_STORAGE_INITIAL_VALUE = localStorage.getItem(GLOBAL_CHAT_OPEN_LOCAL_STORAGE_KEY);

const GLOBAL_CHAT_OPEN_USER_ID_LOCAL_STORAGE_KEY = `${
  import.meta.env.VITE_PRODUCT_CODE
}://chatify/chats/global/open/user/id`;
const GLOBAL_CHAT_OPEN_USER_ID_LOCAL_STORAGE_INITIAL_VALUE = localStorage.getItem(
  GLOBAL_CHAT_OPEN_USER_ID_LOCAL_STORAGE_KEY,
);

export const GLOBAL_CHAT_OPEN_OBSERVABLE = new Observable<string | null>(
  GLOBAL_CHAT_OPEN_LOCAL_STORAGE_INITIAL_VALUE ? GLOBAL_CHAT_OPEN_LOCAL_STORAGE_INITIAL_VALUE : null,
);

export const GLOBAL_CHAT_OPEN_USER_ID_OBSERVABLE = new Observable<string | null>(
  GLOBAL_CHAT_OPEN_USER_ID_LOCAL_STORAGE_INITIAL_VALUE
    ? GLOBAL_CHAT_OPEN_USER_ID_LOCAL_STORAGE_INITIAL_VALUE
    : null,
);

GLOBAL_CHAT_OPEN_OBSERVABLE.addListener((item) => {
  localStorage.setItem(GLOBAL_CHAT_OPEN_LOCAL_STORAGE_KEY, item ?? '');
});

GLOBAL_CHAT_OPEN_USER_ID_OBSERVABLE.addListener((item) => {
  localStorage.setItem(GLOBAL_CHAT_OPEN_USER_ID_LOCAL_STORAGE_KEY, item ?? '');
});

export function openGlobalChat(id: string, userId: string) {
  if (GLOBAL_CHAT_OPEN_OBSERVABLE.value !== id) {
    GLOBAL_CHAT_OPEN_OBSERVABLE.value = id;
    GLOBAL_CHAT_OPEN_USER_ID_OBSERVABLE.value = userId;
  }
}

export function closeGlobalChat() {
  GLOBAL_CHAT_OPEN_OBSERVABLE.value = null;
}

export function toggleGlobalChatOpen(id: string, userId: string) {
  if (GLOBAL_CHAT_OPEN_OBSERVABLE.value === id) {
    closeGlobalChat();
  } else {
    openGlobalChat(id, userId);
  }
}
